import Vue from 'vue';
import {RouteConfig} from 'vue-router';

export const publicRoutes: RouteConfig[] = [
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: (): Promise<{ default: typeof Vue }> => import('../../components/commons/Unauthorized.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      secure: false,
    },
    component: (): Promise<{ default: typeof Vue }> => import(/* webpackChunkName: "login" */ '../../views/Login.vue'),
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    meta: {
      secure: false,
    },
    component: (): Promise<{ default: typeof Vue }> => import(/* webpackChunkName: "login" */ '../../views/ResetPassword.vue'),
  },
  {
    path: '/limited',
    name: 'limited',
    meta: {
      secure: true,
    },
    component: (): Promise<{ default: typeof Vue }> => import(/* webpackChunkName: "login" */ '../../views/Limited.vue'),
  }
];
